<template>
  <div class="form-field">
    <div class="form-field__label" v-if="label">
      <span>{{ label }}</span>
      <span v-if="required" class="form-field__required">*</span>
      <slot name="label-action"></slot>
    </div>
    <v-select
      v-bind="$attrs"
      v-on="inputListeners"
      :value="value"
      outline
      class="form-field__control"
      :class="{ 'form-field__control--readonly': readonlyStyle }"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "FormSelectField",
  inheritAttrs: false,
  props: {
    value: {},
    label: { type: String, default: "" },
    required: { type: Boolean, default: false },
    readonlyStyle: { type: Boolean, default: false }
  },
  computed: {
    inputListeners() {
      return Object.assign({}, this.$listeners, {
        input: value => this.$emit("input", value)
      });
    }
  }
};
</script>

<style scoped lang="css">
.form-field {
  margin: 0;
}

.form-field__label {
  align-items: center;
  color: #475569;
  display: flex;
  font-family: "Inter", "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 600;
  gap: 4px;
  letter-spacing: 0.2px;
  line-height: 1.35;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.form-field__required {
  color: #f44336;
  font-size: 12px;
}

.form-field__control {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.form-field__control >>> .v-input__slot {
  align-items: center !important;
  background: #ffffff !important;
  border-radius: 8px !important;
  display: flex !important;
  margin-bottom: 4px !important;
  min-height: 44px !important;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.form-field__control >>> .v-select__slot {
  align-items: center !important;
  display: flex !important;
  min-height: 44px !important;
}

.form-field__control >>> .v-input__prepend-inner {
  align-self: center !important;
  margin-top: 0 !important;
}

.form-field__control >>> input {
  align-self: center !important;
  height: 44px !important;
  line-height: 20px !important;
  margin-top: 0 !important;
  padding: 0 !important;
}

.form-field__control >>> .v-select__selections {
  align-items: center !important;
  display: flex !important;
  line-height: 20px !important;
  min-height: 44px !important;
  padding: 0 !important;
}

.form-field__control >>> .v-select__selection {
  line-height: 20px !important;
  margin: 0 !important;
}

.form-field__control >>> .v-text-field__details {
  margin-bottom: 0 !important;
  min-height: 18px !important;
  padding: 0 12px !important;
}

.form-field__control >>> .v-messages {
  min-height: 16px !important;
}

.form-field__control >>> .v-input__slot:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05) !important;
}

.form-field__control--readonly >>> .v-input__slot {
  background: #f8fafc !important;
  box-shadow: none !important;
}
</style>
